import { createContext } from 'react';
import { tMetaConnectionModalContext } from './MetaConnectionModa.types.ts';

export const initialState: tMetaConnectionModalContext = {
  loading: false,
  setLoading: () => {},
  connected: false,
  setConnected: () => {},
  step: 0,
  setStep: () => {},
  metaPages: [],
  setMetaPages: () => {},
};

export const MetaConnectionModalContext =
  createContext<tMetaConnectionModalContext>(initialState);
